/**
 * App Component
 *
 * React Router統合
 *
 * PRODUCT_DEV-748: router を props で受け取る。Unizo（`main.tsx`）と
 * Minizo（`main.minizo.tsx`）で router 定義だけが違い、その外側の
 * 「初期化が済むまで Splash を出す」挙動は完全に同じため、ここを複製しない。
 */

import { RouterProvider } from "react-router/dom";
import type { createBrowserRouter } from "react-router";
import { useEffect, useState } from "react";
import { Splash } from "./components/shared/Splash";

type AppRouter = ReturnType<typeof createBrowserRouter>;

export default function App({ router }: { router: AppRouter }) {
  // 初期値（初回ロード開始時は false のことが多い）
  const [initialized, setInitialized] = useState(
    (router as { state?: { initialized?: boolean } }).state?.initialized ?? false,
  );

  useEffect(() => {
    const unsubscribe = (router as { subscribe?: (callback: (state: { initialized?: boolean }) => void) => (() => void) | undefined }).subscribe?.((state: { initialized?: boolean }) => {
      setInitialized(Boolean(state?.initialized));
    });
    return () => unsubscribe?.();
  }, [router]);

  return (
    <>
      {!initialized && <Splash />}
      <RouterProvider router={router} />
    </>
  );
}
